/* eslint-disable jsdoc/require-description */
import { Common } from '@/app/editor/sidebar/global-style/common';
import { DESIGN_GROUP } from '@/constants/elements-map';
import store from '@/app/store/store';
import utils from '@/app/utils/gfUtils';
import HELPER from '@/app/utils/HELPER';
import { base } from '../constant';
import { handleModifyItemStyle } from '@/utils/apply-preset';
import { cloneDeep } from '@/utils/common';
import emitter from '@/emitter';
import { CLASS_GS_CUSTOM, SPACING_DATA_KEY } from '@modules/editor-sidebar';
/**
 *
 */
class TabDesign extends Common {
  public $gfLeftSideBar = jQuery('#gfLeftSideBar');
  public $gfLeftSideBarDesignPanel = this.$gfLeftSideBar.find('.design-panel');
  public $gfSGSubTitle = this.$gfLeftSideBarDesignPanel.find('.gfSGSubTitle');
  public $spacingWrapper = this.$gfLeftSideBarDesignPanel.find('.gf_margin-wrapper, .gf_padding-wrapper');

  public $targetElement: any;
  public timeOutFlagListItemChange: any;
  public spacingDataKey = SPACING_DATA_KEY;

  public buttonBorderData: any;
  public buttonCornerData: any;

  /**
   *
   */
  constructor() {
    super();
    this.buttonBorderData = this.getButtonBorderByID();
    this.buttonCornerData = this.getButtonCornerByID();
  }

  /**
   *
   */
  getGfLeftSideBar() {
    this.$gfLeftSideBar = jQuery('#gfLeftSideBar');
    this.$gfLeftSideBarDesignPanel = this.$gfLeftSideBar.find('.design-panel');
    this.$gfSGSubTitle = this.$gfLeftSideBarDesignPanel.find('.gfSGSubTitle');
    this.$spacingWrapper = this.$gfLeftSideBarDesignPanel.find('.gf_margin-wrapper, .gf_padding-wrapper');
  }

  /**
   *
   */
  initTemplate($targetElement: any) {
    if ($targetElement.attr('class') && $targetElement.attr('class').includes('shopify-payment-button__button')) {
      // Support Dynamic Button
      this.$targetElement = this.getRootTargetElement();
    } else {
      this.$targetElement = $targetElement;
    }
    this.getGfLeftSideBar();
    this.initTemplatePackBorder();
    this.initTemplatePackCorner();

    this.buttonBorderData = this.getButtonBorderByID();
    this.buttonCornerData = this.getButtonCornerByID();

    emitter.off('hook:changeButtonSetting');
    emitter.on('hook:changeButtonSetting', () => {
      this.buttonBorderData = this.getButtonBorderByID();
      this.buttonCornerData = this.getButtonCornerByID();
    });
    emitter.off('gsChangeHistoryForTabDS');
    emitter.on('gsChangeHistoryForTabDS', () => {
      this.initPackBorder();
      this.initPackCorner();
      this.applyValueSpacingWhenOpenSettingDesign(true);
    });
  }

  /**
   *
   */
  setTargetElement($targetElement: any) {
    if ($targetElement && $targetElement.length) {
      const isExistClass =
        $targetElement.attr('class') && $targetElement.attr('class').includes('shopify-payment-button__button');
      // Support Dynamic Button
      this.$targetElement = isExistClass ? this.getRootTargetElement() : $targetElement;
    } else {
      this.$targetElement = $targetElement;
    }
    return false;
  }

  /**
   *
   */
  initSettingGlobalStyle() {
    this.getGfLeftSideBar();
    this.initPackBorder();
    this.initPackCorner();
    this.keyupInputCorner();
    this.focusInputCorner();
    this.cornerChangeUnconstraint();
    this.initPackSpacing();
    this.spacingChangeUnconstraint();
    this.showTooltipUnconstraint();

    store.onChange('currentPresetInPage', () => {
      this.initPackSpacing();
      this.$gfLeftSideBarDesignPanel.find('.gf_gs-spacing-setup').remove();
    });
    store.setValue('renderColumnEnd', '');
  }

  /**
   *
   */
  initTemplatePackBorder() {
    const gsId = 'gs-border';
    const template = this.borderTemplate(gsId);
    const gfSGTitleBarTitle = this.$gfLeftSideBarDesignPanel.find(".gfSGTitleBarTitle[data-caption='Border']");
    if (gfSGTitleBarTitle && gfSGTitleBarTitle.length) {
      const gfSettingGroup = gfSGTitleBarTitle.closest('.gfSettingGroup');
      const $gfSGSettings = gfSettingGroup.find('.gfSGSettings');

      $gfSGSettings.prepend(template);

      (gfSettingGroup.find('.gf_gs-icon-tooltip') as any).gfTooltipsNew({
        postion: 'top',
        desc: this.getMessageTooltip(),
        subTop: 5,
      });
    }
  }

  /**
   *
   */
  getButtonBorderByID() {
    const borderId = this.cornerBorderIDWithButtonLinked().borderStyleId;
    return this.getDataBorder().find((border: any) => border.id === borderId);
  }

  /**
   *
   */
  getButtonCornerByID() {
    const cornerId = this.cornerBorderIDWithButtonLinked().cornerStyleId;
    return this.getDataCorner().find((border: any) => border.id === cornerId);
  }

  /**
   *
   */
  cornerBorderIDWithButtonLinked() {
    const $gfSGSettings = this.$gfLeftSideBar.find('.gfSGSettings');
    const value = $gfSGSettings.find('#gs-button-type').val();
    if (!value) return {};

    const buttonSubType = String(value);
    const dataButtons = this.getDataButtonType();

    const dataButton = dataButtons.find((button: any) => {
      return button.class === buttonSubType;
    });

    return {
      cornerStyleId: dataButton?.value?.cornerStyle,
      borderStyleId: dataButton?.value?.borderStyle,
    };
  }

  /**
   *
   */
  initPackBorder() {
    const gsId = 'gs-border';
    const columnGroupName = 'Border';
    const fields = this.getFieldsByGsId(gsId);
    const classes = this.borderClass();
    this.applySettingHasClassBySnippet(classes, gsId);
    this.changeSettingPack(fields, classes, gsId, columnGroupName);
    this.applyEventEditStyle(this.$gfLeftSideBarDesignPanel);
    this.changeCurrentPreset(gsId, classes);
    this.visibleBoxSetting(fields, classes, gsId, columnGroupName);
  }

  /**
   *changeCurrentPreset
   */
  changeCurrentPreset(gsId = '', classes: any) {
    this.reRenderGsSelect(gsId, classes);
    this.applyEventEditStyle(this.$gfLeftSideBarDesignPanel);

    store.onChange('currentPresetInPage', () => {
      this.reRenderGsSelect(gsId, classes);
      this.applyEventEditStyle(this.$gfLeftSideBarDesignPanel);
      emitter.emit('hook:changeButtonSetting');
    });
  }

  /**
   * reRenderGsSelect
   */
  reRenderGsSelect(gsId = '', classes: any) {
    let options: any = this.borderOptions();
    switch (gsId) {
      case 'gs-corner':
        options = this.cornerOptions();
        break;
    }
    this.$gfLeftSideBarDesignPanel.find(`#gfDropDown_${gsId}`).remove();
    this.$gfLeftSideBarDesignPanel.find(`#${gsId}`).removeData();
    this.$gfLeftSideBarDesignPanel.find(`#${gsId}`).html(options);
    (this.$gfLeftSideBarDesignPanel.find(`#${gsId}`) as any).gfDropDown({});
  }

  /**
   *
   */
  changeSettingPack(fields: any = [], classes: any = [], gsId = '', columnGroupName = '') {
    const $element = this.$gfLeftSideBarDesignPanel.find(`#${gsId}`);
    const _this = this;
    $element.off('input-change').on('input-change', function (e, data) {
      _this.visibleBoxSetting(fields, classes, gsId, columnGroupName);
      _this.updateClassWhenChangeSetting(classes, gsId);
      const val = $(this).val();
      const currentClass = data && data.valBeforeChange;
      const extra = {
        prevClasses: [currentClass],
        removeClasses: classes,
        inputId: $(this).attr('name'),
        addClasses: [val],
      };
      if (!currentClass) {
        _this.addHistory('design-option', false, extra);
      } else {
        _this.addHistory('gs-history-for-tab-ds', false, extra);
      }
      if (!val) {
        _this.applyValueWhenUpdateClass(gsId, currentClass);
        _this.handleResetToDefault(gsId);
      } else {
        _this.modifyStyleGS(gsId, fields);
      }
    });
  }

  /**
   *
   */
  initTemplatePackCorner() {
    const gsId = 'gs-corner';
    const template = this.cornerTemplate(gsId);
    const gfSGTitleBarTitle = this.$gfLeftSideBarDesignPanel.find(".gfSGTitleBarTitle[data-caption='Corner']");
    if (gfSGTitleBarTitle && gfSGTitleBarTitle.length) {
      const gfSettingGroup = gfSGTitleBarTitle.closest('.gfSettingGroup');
      const $gfSGSettings = gfSettingGroup.find('.gfSGSettings');

      $gfSGSettings.prepend(template);
      (gfSettingGroup.find('.gf_gs-icon-tooltip') as any).gfTooltipsNew({
        postion: 'top',
        desc: this.getMessageTooltip(),
        subTop: 5,
      });
    }
  }

  /**
   *
   */
  initPackCorner() {
    const gsId = 'gs-corner';
    const columnGroupName = 'Corner';
    const fields = this.getFieldsByGsId(gsId);
    const classes = this.cornerClass();
    this.applySettingHasClassBySnippet(classes, gsId);
    this.changeSettingPack(fields, classes, gsId, columnGroupName);
    this.applyEventEditStyle(this.$gfLeftSideBarDesignPanel);
    this.changeCurrentPreset(gsId, classes);
    this.visibleBoxSetting(fields, classes, gsId, columnGroupName);
  }

  /**
   *
   */
  visibleBoxSetting(fields: any = [], classes: any = [], gsId = '', caption = '') {
    switch (gsId) {
      case 'gs-border':
        this.checkShowSettingMoreSetting(classes, gsId, caption);
        this.checkShowSettingFieldByIds(fields, classes, gsId);
        break;
      case 'gs-corner':
        this.checkShowCornerSetting(classes, gsId);
        break;
    }
    this.addActionResetToDefaut(gsId);
    // this.addActionRedirectToPreset(gsId);
  }

  /**
   *
   */
  getMessageTooltip() {
    return 'You can apply styles that you setup in Global Styles';
  }

  /**
   *
   */
  getFieldsByGsId(gsId = '') {
    const fields = DESIGN_GROUP[gsId];
    return (fields && Object.keys(fields)) || [];
  }

  /**
   *
   */
  applySettingHasClassBySnippet(classes: any = [], gsId = '') {
    if (!this.getPreset()) {
      this.renderSetupGlobalStyle(gsId);
      return;
    }
    const currentClass = this.getClassGsByEl(this.$targetElement);
    let activeClass = '';
    currentClass.forEach((item: any) => {
      if (classes.includes(item)) {
        activeClass = item;
      }
    });

    const hasValueButtonGS = this.valueButtonGS();
    if (hasValueButtonGS) {
      if (gsId === 'gs-border' && this.buttonBorderData) {
        activeClass = this.buttonBorderData.class;
      } else if (gsId === 'gs-corner' && this.buttonCornerData) {
        activeClass = this.buttonCornerData.class;
      }
    }

    this.$gfLeftSideBarDesignPanel
      .find(`select[name="${gsId}"]`)
      .attr('value', activeClass)
      .val(activeClass)
      .trigger('value-change');
  }

  /**
   *
   */
  updateClassWhenChangeSetting(classes: any = [], gsId = '') {
    if (!this.getPreset()) {
      return;
    }
    const currentGsId: any = this.$gfLeftSideBarDesignPanel.find(`select[name="${gsId}"]`).val();
    if (this.$targetElement) {
      this.$targetElement.removeClass(classes.join(' '));
      this.$targetElement.addClass(currentGsId);
      this.updateDataTemplateSnippetForTabDs(false, classes.join(' '), currentGsId);
    }
  }

  /**
   *
   */
  checkShowSettingFieldByIds(fields: any = [], classes: any = [], gsId = '', isShow = true) {
    const currentGsId = this.$gfLeftSideBarDesignPanel.find(`select[name="${gsId}"]`).val();
    if (currentGsId && classes.includes(currentGsId)) {
      isShow = false;
    }
    const arrCaption = [];
    for (const id of fields) {
      let caption = this.$gfLeftSideBarDesignPanel.find('#' + id).attr('data-caption');
      if (!caption) {
        caption = this.$gfLeftSideBarDesignPanel.find('.' + id).attr('data-caption');
      }
      if (!caption) {
        caption = this.$gfLeftSideBarDesignPanel.find(`[name="${id}"]`).attr('data-caption');
      }
      if (caption) {
        arrCaption.push(caption);
      }
    }
    const length = this.$gfSGSubTitle.length;
    for (let i = 0; i < length; i++) {
      const $this = this.$gfSGSubTitle[i];
      const $parent = $($this).parent();
      let captionItem = $this && $this.innerHTML;
      captionItem = (captionItem && captionItem.replace(/(<([^>]+)>)/gi, '')) || '';
      if (captionItem && arrCaption.includes(captionItem)) {
        if (isShow) {
          $parent.show();
        } else {
          $parent.hide();
        }
      }
    }
  }

  /**
   *
   */
  checkShowSettingMoreSetting(classes: any = [], gsId = '', caption = '', isShow = true) {
    const $elGfMoreSetting = this.$gfLeftSideBarDesignPanel
      .find(`.columns[data-caption="${caption}"]`)
      .find('.gfSGAdv');
    const currentGsId = this.$gfLeftSideBarDesignPanel.find(`select[name="${gsId}"]`).val();
    if (currentGsId && classes.includes(currentGsId)) {
      isShow = false;
    }
    if (isShow) {
      $elGfMoreSetting.show();
    } else {
      $elGfMoreSetting.hide();
    }
  }

  /**
   *
   */
  checkShowCornerSetting(classes: any = [], gsId = '', isShow = true) {
    const $elGfBorderRadius = this.$gfLeftSideBarDesignPanel.find('.gfBorderRadius');
    const $elGfSGSubTitleBorderRadius = this.$gfLeftSideBarDesignPanel.find(".gfSGSubTitle[data-caption='Radius']");
    const currentGsId = this.$gfLeftSideBarDesignPanel.find(`select[name="${gsId}"]`).val();
    if (currentGsId && classes.includes(currentGsId)) {
      isShow = false;
    }
    if (isShow) {
      $elGfBorderRadius.show();
      $elGfSGSubTitleBorderRadius.show();
    } else {
      $elGfBorderRadius.hide();
      $elGfSGSubTitleBorderRadius.hide();
    }
  }

  /**
   *
   */
  addActionRedirectToPreset(gsId: string) {
    const that = this;
    if (['gs-border', 'gs-corner'].includes(gsId)) {
      const borderIdData = this.buttonBorderData;
      const cornerIdData = this.buttonCornerData;

      if (borderIdData || cornerIdData) {
        const $mdSettings = this.$gfLeftSideBarDesignPanel;
        const $gfDropDown = $mdSettings.find(`#gfDropDown_${gsId}`);
        const $btnSelect = $gfDropDown.find('.gfDropDownBody span.gf_gs-select');
        $btnSelect.find('.redirect').remove();
        const currentGsId = $mdSettings.find(`select[name="${gsId}"]`).val();

        if (currentGsId) {
          const redirect = "<div class='redirect'><i class='icon icon-t-blog'></i></div>";
          $btnSelect.append(redirect);
          let type = 'border';
          if ('gs-corner'.includes(gsId)) {
            type = 'corner';
          }

          $btnSelect.off('click');
          $btnSelect
            .find('.redirect')
            .off('click')
            .on('click', function () {
              that.redirectEditGloalStyle(type);
              return;
            });
        }
        return;
      }
    }
    return;
  }

  /**
   *
   */
  addActionResetToDefaut(gsId: string) {
    const $mdSettings = this.$gfLeftSideBarDesignPanel;
    const $gfDropDown = $mdSettings.find(`#gfDropDown_${gsId}`);
    const $btnSelect = $gfDropDown.find('.gfDropDownBody span.gf_gs-select');
    $btnSelect.find('.reset').remove();
    const currentGsId = $mdSettings.find(`select[name="${gsId}"]`).val();

    if (currentGsId) {
      const actionReset = `<div class="reset"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2312 3.15835C10.9895 2.43352 12.2253 2.45145 12.9328 3.20751C13.6403 3.96357 13.5892 5.21159 12.8309 5.93642L10.2978 8.35757C9.53948 9.0824 8.30368 9.06446 7.59617 8.30841C7.40302 8.10201 7.0802 8.09359 6.87511 8.28961C6.67003 8.48564 6.66035 8.81187 6.8535 9.01827C7.96003 10.2007 9.84241 10.2088 10.9973 9.10501L13.5303 6.68386C14.6852 5.58003 14.782 3.68011 13.6755 2.49765C12.569 1.31519 10.6866 1.30707 9.53175 2.4109L6.99869 4.83205C6.79361 5.02807 6.78393 5.3543 6.97708 5.5607C7.17022 5.76711 7.49305 5.77552 7.69814 5.57949L10.2312 3.15835ZM6.54018 7.46011C7.04668 7.47016 7.52341 7.68289 7.86675 8.04979C8.0599 8.25619 8.38273 8.26461 8.58781 8.06858C8.79289 7.87256 8.80257 7.54633 8.60942 7.33993C8.07778 6.77181 7.34174 6.44493 6.56448 6.42949C5.78752 6.41407 5.03295 6.71096 4.46566 7.25319L1.9326 9.67433C1.36531 10.2166 1.02996 10.9614 1.00191 11.7463C0.973848 12.5315 1.25578 13.2924 1.78741 13.8605C2.31905 14.4287 3.05509 14.7556 3.83235 14.771C4.60932 14.7864 5.36389 14.4895 5.93118 13.9473L8.46423 11.5261C8.66932 11.3301 8.67899 11.0039 8.48585 10.7975C8.2927 10.5911 7.96987 10.5827 7.76479 10.7787L5.23173 13.1999C4.85849 13.5566 4.36346 13.7504 3.85666 13.7404C3.35016 13.7303 2.87343 13.5176 2.53009 13.1507C2.18674 12.7838 2.00315 12.2909 2.02144 11.7792C2.03973 11.2673 2.25881 10.7785 2.63205 10.4218L5.16511 8.00063C5.53835 7.64388 6.03338 7.45005 6.54018 7.46011ZM4.07673 1.03635C4.26857 0.946077 4.49586 1.02973 4.58441 1.22319L5.27346 2.72873C5.362 2.92219 5.27826 3.15221 5.08642 3.24248C4.89458 3.33276 4.66729 3.24911 4.57874 3.05565L3.88969 1.5501C3.80115 1.35664 3.88489 1.12663 4.07673 1.03635ZM11.4604 14.7768C11.549 14.9703 11.7763 15.0539 11.9681 14.9636C12.1599 14.8734 12.2437 14.6434 12.1551 14.4499L11.4661 12.9444C11.3775 12.7509 11.1502 12.6672 10.9584 12.7575C10.7666 12.8478 10.6828 13.0778 10.7714 13.2713L11.4604 14.7768ZM3.62038 4.89771C3.51131 5.08261 3.27117 5.15398 3.084 5.05711L1.23964 4.10258C1.05248 4.00572 0.989163 3.7773 1.09823 3.5924C1.20729 3.4075 1.44743 3.33613 1.6346 3.433L3.47896 4.38752C3.66613 4.48439 3.72944 4.71281 3.62038 4.89771ZM12.9608 10.9429C12.7737 10.846 12.5335 10.9174 12.4244 11.1023C12.3154 11.2872 12.3787 11.5156 12.5659 11.6125L14.4102 12.567C14.5974 12.6639 14.8375 12.5925 14.9466 12.4076C15.0557 12.2227 14.9923 11.9943 14.8052 11.8974L12.9608 10.9429Z" fill="currentColor"/>
      </svg></div>`;
      $btnSelect.append(actionReset);

      ($btnSelect.find('.reset') as any).gfTooltipsNew({
        postion: 'top',
        subTop: 5,
        backgroundColor: '#676767',
        desc: 'Unlink style',
      });

      $btnSelect
        .find('.reset')
        .off('click')
        .one('click', function () {
          $gfDropDown.find('li.gf_gs-custom').trigger('click');
          $mdSettings.find(`select[name="${gsId}"]`).attr('value', '').val('').trigger('input-change');
          $gfDropDown.find('ul.gf_gs-select').addClass('active');

          (document as any).getElementById('gfTooltipsNew').innerHTML = '';
        });
    }

    // Disabled border corner when has value gs-button
    $btnSelect.css({
      'pointer-events': 'inherit',
    });
    /**
     *
     */
    const handleDisableDropdown = () => {
      $btnSelect.css({
        border: '1px solid #494949',
        background: '#323232',
        'pointer-events': 'none',
      });
      $btnSelect.find('.icon-arrow-right, .reset').css({
        color: '#757575',
      });
      const $textDp = $gfDropDown.find('span.gf_gs-select-text b');
      if ($textDp.text().toLowerCase().trim() == 'custom') {
        $textDp.text('None');
      }
    };
    if (['gs-border', 'gs-corner'].includes(gsId)) {
      const hasValueButtonGS = this.valueButtonGS();
      if (!hasValueButtonGS) return;
      handleDisableDropdown();
      this.visibleButtonBoxSetting(gsId, false);
    }
  }

  /**
   *
   */
  visibleButtonBoxSetting(gsId: string, isShow = true) {
    const fields = this.getFieldsByGsId(gsId);
    switch (gsId) {
      case 'gs-border':
        this.checkShowSettingMoreSetting([], gsId, 'Border', isShow);
        this.checkShowSettingFieldByIds(fields, [], gsId, isShow);
        break;
      case 'gs-corner':
        this.checkShowCornerSetting([], gsId, isShow);
        break;
    }
  }

  /**
   *
   */
  handleResetToDefault(gsId: string) {
    const fields = this.getFieldsByGsId(gsId);
    const length = fields.length;
    for (let i = 0; i < length; i++) {
      const key = fields[i];
      let $inputItem = this.$gfLeftSideBarDesignPanel.find(`#${key}`);
      if (!$inputItem || !$inputItem.length) {
        $inputItem = this.$gfLeftSideBarDesignPanel.find(`[name="${key}"]`);
      }
      $inputItem.trigger('value-change').trigger('gs-input-change');
    }
    return;
  }

  /**
   *
   */
  getPrefixClasGsId(gsId = '') {
    let prefix = '';
    switch (gsId) {
      case 'gs-border':
        prefix = 'gf_gs-border-';
        break;
      case 'gs-corner':
        prefix = 'gf_gs-corner-';
        break;
    }
    return prefix;
  }

  /**
   *
   */
  getDataByGsId(gsId = '') {
    let data = [];
    switch (gsId) {
      case 'gs-border':
        data = this.getDataBorder();
        break;
      case 'gs-corner':
        data = this.getDataCorner();
        break;
    }
    return data;
  }

  /**
   *
   */
  applyValueWhenUpdateClass(gsId = '', className: any = '') {
    // TODO: items filter theo class
    const items = this.getDataByGsId(gsId);
    if (!className) {
      className = this.$gfLeftSideBarDesignPanel.find(`select[name="${gsId}"]`).val();
    }
    let currentItem: any = className && items.find((item: any) => item.class === className);
    currentItem = this.convertGsValueItem(currentItem);
    const fields = DESIGN_GROUP[gsId] || [];
    this.applyValueInputGs(this.$gfLeftSideBarDesignPanel, currentItem, fields);
  }

  /**
   *
   */
  keyupInputCorner() {
    const _this = this;
    this.$gfLeftSideBarDesignPanel
      .find('.gfBorderRadius')
      .find('.gf_remove-spin-button')
      .off('paste keyup.corner')
      .on('paste keyup.corner', function (e) {
        const $this = $(this);
        const code = e.keyCode ? e.keyCode : e.which;
        if (!code) return;
        let val: any = $this.val();
        val = _this.convertValueNumber(val);
        $this.attr('value', val).val(val);
        const $parent = $this.closest('.gfInputFieldBox');
        const dataName: any = $parent.closest('.gfInputField').attr('data-name');
        _this.setValueForInputCornerByGroupWhenChangeValue(dataName, val);
      });
  }

  /**
   *
   */
  focusInputCorner() {
    this.$gfLeftSideBarDesignPanel
      .find('input')
      .off('focus.corner')
      .on('focus.corner', function () {
        const $this = $(this);
        $this.select();
      });
  }

  /**
   *
   */
  setValueForInputCornerByGroupWhenChangeValue(id: string, val: any) {
    if (!id) return;
    const $gfBorderRadiusWrapper = this.$gfLeftSideBarDesignPanel.find('.gfBorderRadius');
    const $input = $gfBorderRadiusWrapper.find(`input[name="${id}"]`);
    const unconstraint = $input.attr('unconstraint');
    if (!unconstraint || +unconstraint !== 0) return;

    const fields = this.getFieldsByGsId('gs-corner');
    const fieldLength = fields.length;
    // negative
    if (val.match(/^-\d+$/)) {
      val = 0;
    }
    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      const $inputType = $gfBorderRadiusWrapper.find(`input[name="${key}"]`);
      $inputType.val(val).attr('value', val).trigger('value-change').trigger('input-change');
    }
  }

  /**
   *
   */
  cornerChangeUnconstraint() {
    const _this = this;
    const $gfBorderRadiusWrapper = this.$gfLeftSideBarDesignPanel.find('.gfBorderRadius');
    $gfBorderRadiusWrapper
      .find('.gf_gs-action-mode')
      .off('click')
      .on('click', function () {
        const $this = $(this);
        let fields = _this.getFieldsByGsId('gs-corner');
        const group = $this.attr('data-group');
        fields = fields.filter((field) => group && field.includes(group));
        if (!fields || !fields.length) return;
        const $firstElInput = $gfBorderRadiusWrapper.find(`input[name="${fields[0]}"]`);
        let unconstraint: any = $firstElInput.attr('unconstraint');
        unconstraint = unconstraint && +unconstraint === 0 ? 1 : 0;

        let icon = _this.iconConstraint();
        $this.removeClass('unconstraint');
        if (unconstraint && +unconstraint === 1) {
          icon = _this.iconUnconstraint();
          $this.addClass('unconstraint');
        }
        $this.html(icon);

        _this.updateAttrUnconstraint($gfBorderRadiusWrapper, unconstraint, fields);
        _this.updateValueCornerWhenConstraint(unconstraint, fields);
        _this.hideTooltip($this);
        _this.showTooltipUnconstraint();
      });
  }

  /**
   * updateValueCornerWhenConstraint
   */
  updateValueCornerWhenConstraint(unconstraint: number, fields: any = []) {
    if (!fields || !fields.length || unconstraint !== 0) return;
    const fieldLength = fields.length;
    const $gfBorderRadiusWrapper = this.$gfLeftSideBarDesignPanel.find('.gfBorderRadius');
    const defaultCorner = fields.find((field: any) => field.includes('left'));
    const $inputDefault = $gfBorderRadiusWrapper.find(`input[name="${defaultCorner}"]`);
    const inputDefaultVal: any = $inputDefault.val();
    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      const $inputItem = $gfBorderRadiusWrapper.find(`input[name="${key}"]`);
      $inputItem.attr('value', inputDefaultVal).val(inputDefaultVal).trigger('value-change').trigger('input-change');
      this.addHistory('design-option');
    }
  }

  /**
   *
   */
  initPackSpacing() {
    const _this = this;
    const spacings = this.getDataSpacing();
    this.convertValueDefautSpacing();
    this.keyupInputSpacing();

    if (!spacings || !spacings.length) {
      const templateLinkSetupGlobalStyle = '<a href="javascript:;" class="gf_gs-spacing-setup">Setup Global Style</a>';
      const $gfSGSettings = this.$spacingWrapper.closest('.gfSGSettings');
      const hasTemplate = $gfSGSettings.find('.gf_gs-spacing-setup');
      if (!hasTemplate || !hasTemplate.length) {
        $gfSGSettings.append(templateLinkSetupGlobalStyle);
      }
      $gfSGSettings.find('.gf_padding-wrapper').css({ 'margin-bottom': '0' });
      $gfSGSettings
        .find('.gf_gs-spacing-setup')
        .off('click')
        .on('click', function () {
          _this.setupGlobalStyle();
        });
      return;
    }

    this.applyValueSpacingWhenOpenSettingDesign();

    this.spacingInputHoverShowTooltip();

    this.spacingInputFocus();

    this.spacingInputBlur();
  }

  /**
   *
   */
  spacingChangeUnconstraint() {
    const _this = this;
    const $spacingWrapper = this.$spacingWrapper;
    $spacingWrapper
      .find('.gf_gs-action-mode')
      .off('click')
      .on('click', function () {
        const $this = $(this);
        let fields = _this.getFieldsByGsId('gs-spacing');
        const group = $this.attr('data-group');
        fields = fields.filter((field) => group && field.includes(group));
        if (!fields || !fields.length) return;
        const $firstElInput = $spacingWrapper.find(`input[name="${fields[0]}"]`);
        let unconstraint: any = $firstElInput.attr('unconstraint');
        unconstraint = unconstraint && +unconstraint === 0 ? 1 : 0;

        let icon = _this.iconConstraint();
        $this.removeClass('unconstraint');
        if (unconstraint && +unconstraint === 1) {
          icon = _this.iconUnconstraint();
          $this.addClass('unconstraint');
        }
        $this.html(icon);

        _this.updateAttrUnconstraint($spacingWrapper, unconstraint, fields);
        _this.updateValueWhenConstraint(unconstraint, fields);
        _this.hideTooltip($this);
        _this.showTooltipUnconstraint();
      });
  }

  /**
   *
   */
  showTooltipUnconstraint() {
    this.$gfLeftSideBarDesignPanel
      .find('.gf_gs-action-mode')
      .off('mouseenter')
      .on('mouseenter', function () {
        const $this = $(this);
        let desc = 'All Together';
        if ($this.hasClass('unconstraint')) {
          desc = 'Individual';
        }
        ($this as any).gfTooltipsNew({
          postion: 'top',
          desc: desc,
          timeIn: 0,
          timeOut: 0,
          subTop: 5,
        });
        $this.data('gftooltipsnew').settings.desc = desc;
        $this.data('gftooltipsnew').start();
      });
  }

  /**
   * updateAttrUnconstraint
   */
  updateAttrUnconstraint($wrapper: any, unconstraint: number, fields: any = []) {
    if (!fields || !fields.length) return;
    const fieldLength = fields.length;
    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      $wrapper.find(`input[name="${key}"]`).attr('unconstraint', unconstraint);
    }
  }

  /**
   * updateValueWhenConstraint
   */
  updateValueWhenConstraint(unconstraint: number, fields: any = []) {
    if (!fields || !fields.length || unconstraint !== 0) return;
    const fieldLength = fields.length;
    const $spacingWrapper = this.$spacingWrapper;
    let defaultSpacing = fields.find((field: any) => field.includes('left'));
    let $inputDefault = $spacingWrapper.find(`input[name="${defaultSpacing}"]`);
    const isDataAuto = $inputDefault.attr('data-auto');
    const group = $inputDefault.attr('data-group');
    if (isDataAuto) {
      defaultSpacing = fields.find((field: any) => field.includes('top'));
      $inputDefault = $spacingWrapper.find(`input[name="${defaultSpacing}"]`);
    }
    const inputDefaultVal: any = $inputDefault.val();
    const inputDefaultName: any = $inputDefault.attr(this.spacingDataKey);

    const spacing = this.getCurrentSpacing(inputDefaultName);
    // history
    const isMERRoot = this.isMERRoot(group);

    const allClass: any = this.getAllClassByFields(fields);
    const buildClass = this.buildClassGS(fields, spacing);

    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      const $inputItem = $spacingWrapper.find(`input[name="${key}"]`);
      const isDataAutoItem = $inputItem.attr('data-auto');
      if (isDataAutoItem) {
        continue;
      }
      if (inputDefaultName) {
        const prevInputDataKey = $inputItem.attr(this.spacingDataKey);
        let extra = {
          prevClasses: [],
          removeClasses: allClass,
          inputId: key,
          addClasses: buildClass,
        };
        if (prevInputDataKey) {
          extra = {
            ...extra,
            prevClasses: this.buildClassGS(fields, this.getCurrentSpacing(prevInputDataKey)),
          };
          this.addHistory('gs-history-for-tab-ds', isMERRoot, extra);
        } else {
          this.addHistory('design-option', isMERRoot, extra);
        }
        $inputItem.attr('value', inputDefaultVal).val(inputDefaultVal);
        $inputItem.attr(this.spacingDataKey, inputDefaultName);
      } else {
        $inputItem
          .attr('value', this.convertValueToPx(inputDefaultVal))
          .val(this.convertValueToPx(inputDefaultVal))
          .trigger('value-change')
          .trigger('input-change');
        this.addHistory('design-option', isMERRoot);
      }
    }

    const $wrapper = this.$gfLeftSideBarDesignPanel.find(`.${$inputDefault.attr('class')}-wrapper`);
    if (inputDefaultName) {
      $wrapper.find('.gf_remove-spin-button:input:not([readonly])').attr('value', spacing.name).val(spacing.name);
    } else {
      $wrapper.find('.gf_remove-spin-button:input:not([readonly])').attr('value', inputDefaultVal).val(inputDefaultVal);
      this.convertValueDefautSpacing(fields);
    }

    // Update target class, template
    if (inputDefaultName) {
      const allClass: any = this.getAllClassByFields(fields);
      const buildClass = this.buildClassGS(fields, spacing);
      const isMERRoot = this.isMERRoot(group);
      this.updateClassTargetElement(buildClass, allClass, isMERRoot);
      this.modifyStyleGS('gs-spacing', fields);
    }
  }

  /**
   *
   */
  buildClassGS(fields: any = [], spacing: any = {}) {
    const buildClass: any = [];
    if (!fields || !fields.length) return;
    const fieldLength = fields.length;
    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      buildClass.push(this.buildClassSpacing(spacing, key));
    }
    return buildClass;
  }

  /**
   *
   */
  getAllClassByFields(fields: any = []) {
    if (!fields || !fields.length) return;
    const spacings = this.getDataSpacing();
    const spacingLength = spacings.length;
    const fieldLength = fields.length;
    const allClass: any = [];
    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      for (let j = 0; j < spacingLength; j++) {
        allClass.push(this.buildClassSpacing(spacings[j], key));
      }
    }
    return allClass;
  }

  /**
   *
   */
  updateClassTargetElement(buildClass: any = [], allClass: any = [], isMERRoot = false) {
    let $targetElement = this.$targetElement;
    if (isMERRoot) {
      $targetElement = this.getRootTargetElement();
    }
    $targetElement.removeClass(allClass.join(' '));
    buildClass = (buildClass && buildClass.length && buildClass.join(' ')) || '';
    if (buildClass) {
      $targetElement.addClass(buildClass);
    }
    this.updateDataTemplateSnippetForTabDs(isMERRoot, allClass.join(' '), buildClass);
  }

  /**
   *
   */
  spacingInputHoverShowTooltip() {
    const _this = this;
    this.$spacingWrapper
      .find('input')
      .off('mouseenter')
      .on('mouseenter', function () {
        const $this = $(this);
        const $parent = $this.closest('.gfInputFieldBox');
        const dataName = $parent.closest('.gfInputField').attr('data-name');
        const $input = _this.$spacingWrapper.find(`input[name="${dataName}"]`);
        let val: any = $input.val();
        val = _this.convertValueToPx(val);
        const isGs = $input.attr(_this.spacingDataKey);
        if ($this.data('gftooltipsnew')) {
          $this.data('gftooltipsnew').settings.desc = '';
        }
        if (!isGs) return;
        ($this as any).gfTooltipsNew({
          postion: 'top',
          desc: val,
          timeIn: 0,
          timeOut: 0,
          subTop: 5,
        });
        $this.data('gftooltipsnew').settings.desc = val;
        $this.data('gftooltipsnew').start();
      });
  }

  /**
   *
   */
  spacingInputFocus() {
    const _this = this;
    const template = this.spacingTemplate();

    this.$spacingWrapper
      .find('input')
      .off('focus.spacing')
      .on('focus.spacing', function () {
        const $this = $(this);
        const $parent = $this.closest('.gfInputFieldBox');
        const dataName = $parent.closest('.gfInputField').attr('data-name');
        const input = _this.$spacingWrapper.find(`input[name="${dataName}"]`);
        const isDataAuto = input.attr('data-auto');
        if (isDataAuto) {
          return;
        }
        $this.select();
        _this.$spacingWrapper.find(`.gf_${dataName}`).addClass('active');
        $parent.append(template);
        _this.$spacingWrapper
          .closest('.gfSGSettings')
          .find(`.${input.attr('class')}-wrapper`)
          .addClass('active');

        _this.$spacingWrapper
          .find('.gf_gs-dropdown-spacing li')
          .off('mousedown')
          .on('mousedown', function () {
            _this.handleClickSpacingItem($(this), dataName);
          });

        const $elSpacings = _this.$spacingWrapper.find('.gf_gs-dropdown-spacing li');
        const dataKey = input.attr(_this.spacingDataKey);
        _this.openSpacingDropdownActiveItem($elSpacings, dataKey);
      });
  }

  /**
   *
   */
  spacingInputBlur() {
    const _this = this;
    this.$spacingWrapper
      .find('input')
      .off('blur')
      .on('blur', function () {
        const $this = $(this);
        const $parent = $this.closest('.gfInputFieldBox');
        const dataName = $parent.closest('.gfInputField').attr('data-name');
        _this.$spacingWrapper.find(`.gf_${dataName}`).removeClass('active');
        _this.$spacingWrapper.removeClass('active');
        $parent.find('.gf_gs-dropdown-spacing').remove();
      });
  }

  /**
   *
   */
  applyValueSpacingWhenOpenSettingDesign(isHistory = false) {
    let currentClass = this.getClassGsByEl(this.$targetElement);
    const currentClassRoot = this.getClassGsByEl(this.getRootTargetElement());
    currentClass = currentClass.concat(currentClassRoot);
    if (!currentClass || !currentClass.length) {
      return;
    }
    const spacings = this.getDataSpacing();
    const dataSpacingByClass: any = this.convertDataSpacingByClass(spacings);
    const currentDataByClass: any = {};
    const currentClassLength = currentClass.length;
    for (let i = 0; i < currentClassLength; i++) {
      const currentData = dataSpacingByClass[currentClass[i]] || '';
      if (currentData) {
        currentDataByClass[currentData.inherit] = {
          name: currentData.name,
          key: currentData.key,
          value: currentData?.value?.value,
          id: currentData.id,
        };
      }
    }
    const fields = this.getFieldsByGsId('gs-spacing');
    const fieldLength = fields.length;
    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      const data = currentDataByClass[key];
      if (data) {
        const $el = this.$gfLeftSideBarDesignPanel.find(`input[name="${key}"]`);
        const classRender = `.gf_${key}`;
        const $parent = $el.closest(classRender);
        $el.attr('value', data.value).val(data.value);
        $el.attr(this.spacingDataKey, this.getSignature(data));
        $parent.find('.gf_remove-spin-button').attr('value', data.name).val(data.name);
        if (isHistory) {
          this.modifyStyleGS('gs-spacing', fields);
        }
      }
    }
  }
  /**
   *
   */
  keyupInputSpacing() {
    const _this = this;
    const $spacingWrapper = this.$spacingWrapper;
    $spacingWrapper
      .find('.gf_remove-spin-button:input:not([readonly])')
      .off('paste keyup.spacing')
      .on('paste keyup.spacing', function (e) {
        const $this = $(this);
        const code = e.keyCode ? e.keyCode : e.which;
        if (!code) return;
        if (code === 13) {
          $this.blur();
        }

        let val: any = $this.val();
        val = _this.convertValueNumber(val);
        $this.attr('value', val).val(val);

        const $parent = $this.closest('.gfInputFieldBox');
        const dataName: any = $parent.closest('.gfInputField').attr('data-name');
        // const $input = $spacingWrapper.find(`input[name="${dataName}"]`);
        // const inputVal: any = $input.val() || "";
        // if(_this.convertValueToPx(val) === _this.convertValueToPx(inputVal)) {
        //   return;
        // }
        _this.setValueForInputByGroupWhenChangeValue(dataName, val);
        _this.removeClassWhenChangeValue(dataName);
        $spacingWrapper.find('.gf_gs-dropdown-spacing li').removeClass('active');
      });
  }

  /**
   *
   */
  setValueForInputByGroupWhenChangeValue(id: string, val: string) {
    if (!id) return;
    const $input = this.$spacingWrapper.find(`input[name="${id}"]`);
    const group = $input.attr('data-group');
    const unconstraint = $input.attr('unconstraint');
    if (!unconstraint || +unconstraint !== 0) return;

    let fields = this.getFieldsByGsId('gs-spacing');
    fields = fields.filter((item) => group && item.includes(group));
    const fieldLength = fields.length;

    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      const $inputType = this.$spacingWrapper.find(`input[name="${key}"]`);
      const isDataAuto = $inputType.attr('data-auto');
      if (isDataAuto) {
        continue;
      }
      const newValue = this.convertValueToPx(val);
      $inputType.val(newValue).attr('value', newValue).trigger('value-change').trigger('input-change');
    }
    this.convertValueDefautSpacing(fields);
  }

  /**
   * removeClassWhenChangeValue
   */
  removeClassWhenChangeValue(id: string) {
    if (!id) return;
    const $input = this.$spacingWrapper.find(`input[name="${id}"]`);
    const dataKey = $input.attr(this.spacingDataKey);
    const unconstraint = $input.attr('unconstraint');
    const group = $input.attr('data-group');

    if (dataKey) {
      let fields = this.getFieldsByGsId('gs-spacing');
      fields = fields.filter((item) => group && item.includes(group));
      if (unconstraint && +unconstraint === 1) {
        fields = [id];
      }

      const fieldLength = fields.length;
      for (let i = 0; i < fieldLength; i++) {
        const key = fields[i];
        const $inputItem = this.$spacingWrapper.find(`input[name="${key}"]`);
        $inputItem.removeAttr(this.spacingDataKey);
      }

      const allClass: any = this.getAllClassByFields(fields);
      const isMERRoot = this.isMERRoot(group);
      this.updateClassTargetElement([], allClass, isMERRoot);
    }
  }

  /**
   *
   */
  handleClickSpacingItem($el: any, inherit = '') {
    // inherit Ex: margin-top padding-top
    const dataValue = $el.attr('data-value');
    const dataType = $el.attr('data-type');
    if (dataType) {
      this.redirectEditGloalStyle(dataType);
      return;
    }
    if (!dataValue) {
      return;
    }
    const spacing = this.getCurrentSpacing(dataValue);
    if (!spacing) {
      return;
    }

    this.setValueForInputByGroupWhenClickSpacingItem(inherit, spacing.name);

    this.setClassForInputByGroupWhenClickSpacingItem(inherit, spacing);
  }

  /**
   * setValueForInputByGroupWhenClickSpacingItem
   */
  setValueForInputByGroupWhenClickSpacingItem(id: string, name: string) {
    if (!id) return;
    const $input = this.$spacingWrapper.find(`input[name="${id}"]`);
    const unconstraint = $input.attr('unconstraint');
    let classRender = `.${$input.attr('class')}-wrapper`; // gf_margin-top gf_margin-wrapper"
    if (unconstraint && +unconstraint === 1) {
      classRender = `.gf_${id}`;
    }
    const $gfSetting = this.$gfLeftSideBarDesignPanel.find(`${classRender}`);
    $gfSetting.find('.gf_remove-spin-button:input:not([readonly])').val(name);
  }

  /**
   *
   */
  setClassForInputByGroupWhenClickSpacingItem(id: string, spacing: any) {
    if (!spacing || !id) return;
    const spacingValue = spacing.value.value;
    const $input = this.$spacingWrapper.find(`input[name="${id}"]`);
    const unconstraint = $input.attr('unconstraint');
    const group = $input.attr('data-group');
    const isMERRoot = this.isMERRoot(group);
    const gsId = 'gs-spacing';
    let fields = this.getFieldsByGsId(gsId);
    fields = fields.filter((item) => group && item.includes(group));
    if (unconstraint && +unconstraint === 1) {
      fields = [id];
    }

    const allClass: any = this.getAllClassByFields(fields);
    const buildClass = this.buildClassGS(fields, spacing);
    this.$targetElement.removeClass(allClass.join(' '));

    const signature = this.getSignature(spacing);
    const prevInputDataKey = $input.attr(this.spacingDataKey);

    const fieldLength = fields.length;
    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      const $inputItem = this.$spacingWrapper.find(`input[name="${key}"]`);
      const isDataAuto = $inputItem.attr('data-auto');
      if (isDataAuto) {
        continue;
      }
      $inputItem.attr(this.spacingDataKey, signature);

      $inputItem.val(spacingValue).attr('value', spacingValue);
      this.updateClassTargetElement(buildClass, allClass, isMERRoot);
    }
    if (buildClass) {
      this.modifyStyleGS(gsId, fields);
    }
    // history
    let extra = {
      prevClasses: [],
      removeClasses: allClass,
      inputId: id,
      addClasses: buildClass,
    };
    if (prevInputDataKey) {
      extra = {
        ...extra,
        prevClasses: this.buildClassGS(fields, this.getCurrentSpacing(prevInputDataKey)),
      };
      this.addHistory('gs-history-for-tab-ds', isMERRoot, extra);
    } else {
      this.addHistory('design-option', isMERRoot, extra);
    }
  }

  /**
   *
   */
  openSpacingDropdownActiveItem(items: any = [], value = '') {
    if (!value) return;
    const itemLength = items.length;
    for (let i = 0; i < itemLength; i++) {
      const $thisItem = $(items[i]);
      const dataValue = $thisItem.attr('data-value');
      if (dataValue === value) {
        $thisItem.addClass('active');
        break;
      }
    }
  }

  /**
   *
   */
  convertValueDefautSpacing(fields: any = []) {
    if (!fields || !fields.length) {
      fields = this.getFieldsByGsId('gs-spacing');
    }
    // Remove unit Ex: 10px -> 10
    const fieldLength = fields.length;
    for (let i = 0; i < fieldLength; i++) {
      const key = fields[i];
      this.convertValueItemSpacing(key);
    }
  }

  /**
   *
   */
  convertValueItemSpacing(field = '') {
    if (!field) return;
    const $el = this.$gfLeftSideBarDesignPanel.find(`input[name="${field}"]`);
    const $elVal: any = $el.val();
    if (!$elVal) {
      return;
    }
    const detachVal: any = this.detachUnitAndValue($elVal);
    const classRender = `.gf_${field}`;
    if (detachVal?.value) {
      $el.closest(classRender).find('.gf_remove-spin-button').attr('value', detachVal.value).val(detachVal.value);
    }
  }

  /**
   *
   */
  getCurrentSpacing(id: any) {
    const spacings = this.getDataSpacing();
    const spacing = spacings.find((item: any) => item.id == id || item.key == id);
    return spacing;
  }

  /**
   *
   */
  iconUnconstraint() {
    return utils.svgIcon('unconstraint');
  }
  /**
   *
   */
  iconConstraint() {
    return utils.svgIcon('constraint');
  }

  /**
   *
   */
  convertValueToPx(val: string) {
    if (!val) return '';
    val = String(val);
    if (val === '-') {
      return val;
    }
    if (!val.includes('px')) {
      val = val + 'px';
    }
    return val;
  }

  /**
   *
   */
  convertValueNumber(val: any) {
    // const reg = new RegExp("^[-0-9]+$", /^(-?\d+)$/);
    const reg = new RegExp(/^(-?\d*\.?\d*)$/);
    if (!val) {
      val = '';
    }
    if (val && val != '-') {
      if (!reg.test(val)) {
        val = '';
      }
    }
    // replace 00010 -> 10
    val = (val && val != 0 && val.replace(new RegExp(/^0+|(?:\.|(\..*?))0+$/g), '')) || val;
    // val = parseInt(val);
    return val;
  }

  /**
   *
   */
  hideTooltip($el: any) {
    if ($el.data('gftooltipsnew')) {
      $el.data('gftooltipsnew').stop();
      (document as any).getElementById('gfTooltipsNew').innerHTML = '';
    }
  }

  /**
   * modifyStyleGS
   */
  modifyStyleGS(gsId: string, fields: any) {
    const $mdSettings = this.$gfLeftSideBar.find('#md-settings');
    const type: any = $mdSettings.attr('data-editting');
    const dataId = $mdSettings?.data()?.edittingID;
    const mewDataId = dataId && dataId.replace('e-', '').replace('m-', '').replace('r-', '');
    if (!dataId) return;
    const $gfFrameContents = jQuery('#gfFrame').contents();
    const keyStyle = HELPER.getKeyDataSetting(base._style, mewDataId, type);
    const dataFields = this.getDataFieldsByGsId(dataId, gsId, fields);
    const newStyle = handleModifyItemStyle({ keyStyle, gfFrameContents: $gfFrameContents, fieldValues: [dataFields] });
    return newStyle;
  }

  /**
   *
   */
  getDataFieldsByGsId(dataId: string, gsId: string, fields: any) {
    if (!gsId || !dataId) {
      return;
    }
    const dataFields: any = cloneDeep(DESIGN_GROUP[gsId]);
    if (!dataFields || !Object.keys(dataFields).length) return;
    const targetClass = this.getTargetClass();
    const length = Object.keys(dataFields).length;
    const newDataFields: any = {};
    for (let i = 0; i < length; i++) {
      const key = Object.keys(dataFields)[i];
      if (fields.includes(key)) {
        const selector = dataFields[key]?.selector || '';
        const targetSelector = targetClass && !selector ? `#${dataId} ${targetClass}` : `#${dataId}`;
        dataFields[key].selector = targetSelector;
        newDataFields[key] = dataFields[key];
      }
    }
    return newDataFields;
  }

  /**
   *
   */
  getRootTargetElement() {
    const $gfFrame = jQuery('#gfFrame');
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const targetId = $gfLeftSideBar.find('.md-title .mer-title').attr('data-id');
    const merId = '#' + targetId;
    return $gryffBody.find(merId);
  }

  /**
   *
   */
  isMERRoot(group: any) {
    if (!group) return false;
    return ['margin'].includes(group);
  }

  /**
   *
   */
  valueButtonGS() {
    const hasValueButtonGS = this.$gfLeftSideBar.find('#gs-button-type').val();
    if (!hasValueButtonGS || hasValueButtonGS === CLASS_GS_CUSTOM) return false;
    return true;
  }

  /**
   * addHistory
   */
  addHistory(name = 'design-option', isMERRoot = false, extra: any = {}) {
    const targetId = this.$gfLeftSideBar.find('.md-title .mer-title').attr('data-id');
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const merId = '#' + targetId;
    const targetClass = isMERRoot ? merId : `${merId} ${this.getTargetClass()}`;
    extra = {
      ...extra,
      targetClass: targetClass,
    };
    $gryffEditor.data('gfhistory').addHistory(name, targetId, extra);
    $gryffEditor.data('gfhistory').captureMERSettings();
  }
}

export const renderTabDesign = new TabDesign();
